import { Form, Formik, getIn } from 'formik';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import pricingApi, { PricingType } from '../../../APIs/pricing';
import {
  Alert,
  Button,
  FormContainer,
  Input,
  Radio,
  TextArea,
  Typography,
} from '../../../designComponents';
import SelectDropDown from '../../../designComponents/SelectDropdown';
import { requestAPI } from '../../../utils';
import validationSchema from './validation';

type Props = {};

const AddPricingContainer = styled.div`
  background-color: white;
  padding: 20px;
  /* max-width: 500px; */
`;

const AddPricing = (_props: Props) => {
  const [errorMessage, setErrorMessage] = useState('');

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [initialValues, _setInitialValues] = useState({
    priceDenom: '',
    recurringPeriod: '',
    planDescription: [{ title: '', description: '' }],
    title: '',
    price: 100,
    isRecurring: false,
    isActive: false,
    planType: '',
    notes: '',
  });
  const [showRecurringPeriod, setShowRecurringPeriod] = useState(
    initialValues.isRecurring
  );

  const handleAddPricing = async (values: PricingType) => {
    try {
      setLoading(true);
      await requestAPI(
        pricingApi.createPricing({
          priceDenom: values.priceDenom,

          planDescription: values.planDescription,
          title: values.title,
          price: values.price,
          isRecurring: values.isRecurring,
          ...(values.isRecurring && {
            recurringPeriod: values.recurringPeriod,
          }),
          isActive: values.isActive,
          planType: values.planType,
          notes: values.notes,
        })
      );
      setLoading(false);
      toast.success('Price added successfully');
      navigate(-1);
    } catch (error: any) {
      if (typeof error === 'string') {
        setErrorMessage(error);
      }
      if (error.error && typeof error.error === 'string') {
        setErrorMessage(error.error);
      }
      setLoading(false);
    }
  };
  return (
    <AddPricingContainer>
      <div
        style={{
          maxWidth: '500px',
        }}
      >
        <Typography size={16} color="#333" style={{ marginBottom: '20px' }}>
          Add Price
        </Typography>
        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={handleAddPricing}
          validationSchema={validationSchema}
        >
          {({ values, setFieldValue, handleSubmit, errors, touched }) => (
            <Form onSubmit={handleSubmit}>
              {errorMessage ? <Alert type="error" text={errorMessage} /> : null}

              <div>
                <FormContainer
                  label="Price"
                  error={touched.price ? errors.price : ''}
                >
                  <Input
                    name="price"
                    value={values.price}
                    onChange={(e) => setFieldValue('price', e.target.value)}
                  />
                </FormContainer>
                <FormContainer
                  label="Price Denom"
                  error={touched.priceDenom ? errors.priceDenom : ''}
                >
                  <SelectDropDown
                    placeholder="Select Price demon"
                    selected={values.priceDenom}
                    onSelect={(value: string, _record: any) => {
                      setFieldValue('priceDenom', value);
                    }}
                    options={[
                      { label: 'USD', value: 'USD' },
                      { label: 'EUR', value: 'EUR' },
                      { label: 'CAD', value: 'CAD' },
                      { label: 'AUD', value: 'AUD' },
                      { label: 'AED', value: 'AED' },
                      { label: 'GBP', value: 'GBP' },
                    ]}
                  />
                </FormContainer>

                <FormContainer
                  label="Title"
                  error={touched.title ? errors.title : ''}
                >
                  <Input
                    name="title"
                    value={values.title}
                    onChange={(e) => setFieldValue('title', e.target.value)}
                  />
                </FormContainer>

                <FormContainer
                  label="Plan Type"
                  error={touched.planType ? errors.planType : ''}
                >
                  <SelectDropDown
                    placeholder="select"
                    selected={values.planType}
                    onSelect={(value: string, _record: any) =>
                      setFieldValue('planType', value)
                    }
                    options={[
                      { label: 'DRAFTS JOB', value: 'DRAFTS_JOB' },
                      { label: 'Test', value: 'TEST' },
                    ]}
                  />
                </FormContainer>

                <FormContainer
                  label="Note"
                  error={touched.notes ? errors.notes : ''}
                >
                  <TextArea
                    name="notes"
                    maxRow={4}
                    value={values.notes}
                    onChange={(e) => setFieldValue('notes', e.target.value)}
                  />
                </FormContainer>
              </div>

              <FormContainer label="Recurring">
                <div style={{ display: 'flex', gap: '30px' }}>
                  <Radio
                    label="Yes"
                    name="isRecurring"
                    value="isRecurring"
                    checked={values.isRecurring}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const { checked } = e.target;
                      setFieldValue('isRecurring', checked);
                      setShowRecurringPeriod(checked);
                    }}
                  />
                  <Radio
                    label="No"
                    name="isRecurring"
                    value="not-recurring"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const { checked } = e.target;
                      setFieldValue('isRecurring', !checked);
                      setShowRecurringPeriod(!checked);
                    }}
                    checked={!values.isRecurring}
                  />
                </div>
              </FormContainer>
              {showRecurringPeriod && (
                <FormContainer label="Recurring Period">
                  <SelectDropDown
                    placeholder="Select Recurring Period"
                    selected={values.recurringPeriod}
                    onSelect={(value: string, _record: any) => {
                      setFieldValue('recurringPeriod', value);
                    }}
                    options={[
                      { label: 'DAILY', value: 'DAILY' },
                      { label: 'WEEKLY', value: 'WEEKLY' },
                      { label: 'MONTHLY', value: 'MONTHLY' },
                      {
                        label: 'EVERY_THREE_MONTHS',
                        value: 'EVERY_THREE_MONTHS',
                      },
                      { label: 'EVERY_SIX_MONTHS', value: 'EVERY_SIX_MONTHS' },
                      { label: 'YEARLY', value: 'YEARLY' },
                    ]}
                  />
                </FormContainer>
              )}
              <FormContainer label="Active">
                <div style={{ display: 'flex', gap: '30px' }}>
                  <Radio
                    label="Yes"
                    name="isActive"
                    value="isActive"
                    checked={values.isActive}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const { checked } = e.target;
                      setFieldValue('isActive', checked);
                    }}
                  />
                  <Radio
                    label="No"
                    name="isActive"
                    value="not-active"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const { checked } = e.target;
                      setFieldValue('isActive', !checked);
                    }}
                    checked={!values.isActive}
                  />
                </div>
              </FormContainer>
              <div
                style={{
                  marginBottom: '40px',
                  backgroundColor: '#F5F5F5',
                  padding: '10px',
                }}
              >
                {values.planDescription.map((plan, index) => (
                  <>
                    <FormContainer
                      label="Plan Title"
                      error={
                        getIn(touched, `planDescription[${index}].title`) &&
                        getIn(errors, `planDescription[${index}].title`)
                          ? getIn(errors, `planDescription[${index}].title`)
                          : ''
                      }
                    >
                      <Input
                        name={`planDescription.${index}.title`}
                        value={plan.title}
                        onChange={(e) =>
                          setFieldValue(
                            `planDescription.${index}.title`,
                            e.target.value
                          )
                        }
                        placeholder="Title"
                      />
                    </FormContainer>
                    <FormContainer
                      label="Plan Description"
                      error={
                        getIn(
                          touched,
                          `planDescription[${index}].description`
                        ) &&
                        getIn(errors, `planDescription[${index}].description`)
                          ? getIn(
                              errors,
                              `planDescription[${index}].description`
                            )
                          : ''
                      }
                    >
                      <Input
                        name={`planDescription.${index}.description`}
                        value={plan.description}
                        onChange={(e) =>
                          setFieldValue(
                            `planDescription.${index}.description`,
                            e.target.value
                          )
                        }
                        placeholder="Description"
                      />
                    </FormContainer>
                  </>
                ))}

                <Button
                  variant="gray"
                  onClick={() =>
                    setFieldValue('planDescription', [
                      ...values.planDescription,
                      { title: '', description: '' },
                    ])
                  }
                >
                  Add Another Description
                </Button>
              </div>
              <div>
                <Button type="submit" isLoading={loading}>
                  Create Pricing
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </AddPricingContainer>
  );
};

export default AddPricing;
